import React, { useEffect, useState } from "react";
import Header from "../Core/Header";
import Footer from "../Core/Footer";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { termConcition } from "../../service/operations/api_methods";

const Termscondition = () => {
  const token =
    useSelector((state) => state.auth.token) || Cookies.get("roam-token");
  const [termsData, setTermsData] = useState(" Not any specific to say!!!!");

  useEffect(() => {
    const getTermCondition = async () => {
      try {
        const response = await termConcition(token);
        console.log(response);
        setTermsData(response.data.terms.content);
      } catch (error) {
        console.log(error);
      }
    };

    getTermCondition();
  }, []);

  return (
    <div style={{ padding: "30px" }}>
      <Header />
      <div style={{paddingTop:"50px"}}>
      <div dangerouslySetInnerHTML={{ __html: termsData }} /></div>

      <Footer />
    </div>
  );
};

export default Termscondition;
